import { PropTypes } from "prop-types"
import classNames from "classnames"

import Translate from "../../Translate"

import FieldLabel from "./FieldLabel"
import FieldInput from "./FieldInput"
import InputError from "./InputError"
import errorPropTypes from "../errorPropTypes"

export function Field({ children, className, id, error = {}, touched = false }) {
  const { key, params, hasError } = error
  const errorId = `${id}-error`

  return (
    <div
      className={classNames("oj-field", className, {
        "state-error": hasError,
        "state-touched": touched && !hasError
      })}
    >
      <div className="outline-field">{children}</div>
      {hasError && (
        <InputError id={errorId}>
          <Translate id={key} data={params} />
        </InputError>
      )}
    </div>
  )
}

Field.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  error: PropTypes.shape(errorPropTypes),
  id: PropTypes.string,
  touched: PropTypes.bool
}

Field.Label = FieldLabel
Field.Input = FieldInput

export default Field
